"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SheetInfoImpl = void 0;
const api_external_contract_js_1 = require("@tableau/api-external-contract-js");
class SheetInfoImpl {
    constructor(_name, _sheetType, _sheetSize, _index, _isActive, _isHidden, _url) {
        this._name = _name;
        this._sheetType = _sheetType;
        this._sheetSize = _sheetSize;
        this._index = _index;
        this._isActive = _isActive;
        this._isHidden = _isHidden;
        this._url = _url;
    }
    get name() {
        return this._name;
    }
    set name(sheetName) {
        this._name = sheetName;
    }
    get sheetSize() {
        return this._sheetSize;
    }
    set sheetSize(value) {
        this._sheetSize = value;
    }
    get sheetType() {
        return this._sheetType;
    }
    get sheetPath() {
        return {
            sheetName: this.name,
            isDashboard: this.sheetType === api_external_contract_js_1.SheetType.Dashboard,
            // TODO - Stories
        };
    }
    get index() {
        return this._index;
    }
    get isActive() {
        return this._isActive;
    }
    set active(active) {
        this._isActive = active;
    }
    get isHidden() {
        return this._isHidden;
    }
    get url() {
        return this._url;
    }
}
exports.SheetInfoImpl = SheetInfoImpl;
//# sourceMappingURL=SheetInfoImpl.js.map